import { Steps } from "antd";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { taskByGroup } from "./task-by-group";

import './user-study.scss';

export enum StudyGroup {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
}

export interface UserStudyProps {
  group: StudyGroup;
}

const UserStudy = (props: any) => {
  const [progress, setProgress] = useState(0);
  const [task1Progress, setTask1Progress] = useState(0);
  const [task2Progress, setTask2Progress] = useState(0);

  const itemProgressState = (itemNumber: number, progress: number) => {
    if (itemNumber < progress) {
      return 'complete';
    } else if (itemNumber === progress) {
      return 'current';
    } else {
      return 'pending';
    }
  };

  const Task1 = useCallback(() => {
    // Show expanded steps if user is in progress
    if (progress === 1) {
      return (<Steps 
        style={{
          paddingLeft: '10px',
        }}
        progressDot
        direction="vertical"
        current={task1Progress}
        items={[
          {
            title: (<a href={taskByGroup[props.group].flow1.preTaskSurveyLink} target="_blank" className={`${itemProgressState(0, task1Progress)}`} onClick={() => setTask1Progress(1)}>
              Pre-Task 1 Survey
            </a>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow1.preTaskFlow} target="_blank" className={`${itemProgressState(1, task1Progress)}`} onClick={() => setTask1Progress(2)}>
              Pre-Task 1 Preparation
            </Link>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow1.interfaceTutorial} target="_blank" className={`${itemProgressState(2, task1Progress)}`} onClick={() => setTask1Progress(3)}>
              Task 1 Interface Tutorial
            </Link>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow1.taskFlow} target="_blank" className={`${itemProgressState(3, task1Progress)}`} onClick={() => setTask1Progress(4)}>
              Task 1
            </Link>),
          },
          {
            title: (<a href={taskByGroup[props.group].flow1.postTaskSurveyLink} target="_blank" className={`${itemProgressState(4, task1Progress)}`} onClick={() => {
              setProgress(2);
              setTask1Progress(5);
            }}>
              Post-Task 1 Survey
            </a>),
          },
        ]}
      />);
    } else {
      return (<a className={`${itemProgressState(1, progress)}`} onClick={() => setProgress(1)}>Task 1</a>);
    }
  }, [progress, task1Progress]);

  const Task2 = useCallback(() => {
    // Show expanded steps if user is in progress
    if (progress === 2) {
      return (<Steps 
        style={{
          paddingLeft: '10px',
        }}
        progressDot
        direction="vertical"
        current={task2Progress}
        items={[
          {
            title: (<a href={taskByGroup[props.group].flow2.preTaskSurveyLink} target="_blank" className={`${itemProgressState(0, task2Progress)}`} onClick={() => setTask2Progress(1)}>
              Pre-Task 2 Survey
            </a>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow2.preTaskFlow} target="_blank" className={`${itemProgressState(1, task2Progress)}`} onClick={() => setTask2Progress(2)}>
              Pre-Task 2 Preparation
            </Link>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow2.interfaceTutorial} target="_blank" className={`${itemProgressState(2, task2Progress)}`} onClick={() => setTask2Progress(3)}>
              Task 2 Interface Tutorial
            </Link>),
          },
          {
            title: (<Link to={'/'+taskByGroup[props.group].flow2.taskFlow} target="_blank" className={`${itemProgressState(4, task2Progress)}`} onClick={() => setTask2Progress(4)}>
              Task 2
            </Link>),
          },
          {
            title: (<a href={taskByGroup[props.group].flow2.postTaskSurveyLink} target="_blank" className={`${itemProgressState(5, task2Progress)}`} onClick={() => {
              setProgress(3);
              setTask2Progress(5);
            }}>
              Post-Task 2 Survey
            </a>),
          },
        ]}
      />);
    } else {
      return (<a className={`${itemProgressState(2, progress)}`} onClick={() => setProgress(2)}>Task 2</a>);
    }
  }, [progress, task2Progress]);

  return (
    <div className="user-study">
      {
        progress < 4 ? (
          <>
            <h3>Welcome to the user study! Here is the agenda for the study.</h3>
            <Steps
              className="steps"
              progressDot
              current={progress}
              direction="vertical"
              items={[
                {
                  title: (<a href={taskByGroup[props.group].preStudySurveyLink} target="_blank" className={`${itemProgressState(0, progress)}`} onClick={() => setProgress(1)}>
                    Pre-Study Survey
                  </a>),
                },
                {
                  title: Task1(),
                },
                {
                  title: Task2(),
                },
                {
                  title: (<a href={taskByGroup[props.group].postStudySurveyLink} target="_blank" className={`${itemProgressState(3, progress)}`} onClick={() => setProgress(4)}>
                    Post-Study Survey
                  </a>),
                },
              ]}
            />
          </>
        ) :
        <h2>Thank you for participating! 🎉</h2>
      }

      {/* 
        Select which study group (ABCD)
        Prestudy survey
        Pretask survey
        Prestudy Flow (creating diagram about topic 1)
        Flow 1
        Post task survey
        Pretask survey
        Prestudy Flow
        Flow 2
        Post task survey
        Post study survey
       */}
    </div>
  )
}

export default UserStudy;